import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import {generateQrOnline} from '../../../shared/utils/generateQr';
import {RequestStatus, RequestStep} from 'src/app/shared/models/request';
import {ApiService} from 'src/app/shared/services/api.service';
import {LangService, NavigateService} from 'ngx-satoris';
import {PrintService} from '../../../shared/services/print.service';
import {PrintQrCodeListData, DocsPrintType} from 'src/app/shared/models/print';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-admin-request-qr-list',
  templateUrl: './admin-request-qr-list.component.html',
  styleUrls: ['./admin-request-qr-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdminRequestQrListComponent implements OnInit, OnDestroy {

  data: RequestStep[] | any;
  status = RequestStatus;
  environment = environment;

  constructor(public print: PrintService,
    public api: ApiService,
    private router: Router,
    private nav: NavigateService,
    private lang: LangService) {
    this.data = this.router.getCurrentNavigation().extras.state;
    if(!this.data) this.nav.goBack();
  }

  ngOnInit(): void {
    if(Array.isArray(this.data)) {
      this.data?.forEach((payment: RequestStep, i: number) => {
        const placeId = environment.formHasBookTimeSlotStep ? payment.timeslot_place_id : payment.created_place_id;
        this.data[i].qrCode = generateQrOnline(payment.id, payment.signature, placeId, payment.externalId);
      });
    } else {
      const obj = this.data;
      this.data = [];
      Object.keys(obj).forEach((key: string) => {
        this.data.push(obj[key]);
        const placeId = environment.formHasBookTimeSlotStep ? obj[key].timeslot_place_id : obj[key].created_place_id;
        this.data[this.data.length - 1].qrCode = generateQrOnline(obj[key].id, obj[key].signature, placeId, obj[key].externalId);
      });
    }

    document.querySelector('html').classList.add('unlockScroll');
  }

  ngOnDestroy() {
    document.querySelector('html').classList.remove('unlockScroll');
  }

  goToPreviousUrl() {
    this.router.navigateByUrl(localStorage.getItem('previous_url'));
  }

  printQrCodeList() {
    const printQrCodeListData: PrintQrCodeListData = {
      title: this.lang.transform('payment.qrList.title'),
      dataList: this.data
    };
    this.print.print<PrintQrCodeListData>(DocsPrintType.QRCODE_LIST, printQrCodeListData);
  }
}
